import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { cn } from '../../utils/cn';
// Modern card with elevation shadows
const ElevatedCard = React.forwardRef(({ className, children, elevation = 'medium', ...props }, ref) => {
    const elevationClasses = {
        low: 'shadow-sm hover:shadow-md',
        medium: 'shadow-md hover:shadow-lg',
        high: 'shadow-lg hover:shadow-xl'
    };
    return (_jsx("div", { ref: ref, className: cn('bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-xl transition-all duration-200', elevationClasses[elevation], className), ...props, children: children }));
});
ElevatedCard.displayName = 'ElevatedCard';
const ElevatedCardHeader = React.forwardRef(({ className, ...props }, ref) => (_jsx("div", { ref: ref, className: cn('px-6 py-5', className), ...props })));
ElevatedCardHeader.displayName = 'ElevatedCardHeader';
const ElevatedCardTitle = React.forwardRef(({ className, ...props }, ref) => (_jsx("h3", { ref: ref, className: cn('text-xl font-semibold text-gray-900 dark:text-gray-100', className), ...props })));
ElevatedCardTitle.displayName = 'ElevatedCardTitle';
const ElevatedCardContent = React.forwardRef(({ className, ...props }, ref) => (_jsx("div", { ref: ref, className: cn('px-6 pb-6', className), ...props })));
ElevatedCardContent.displayName = 'ElevatedCardContent';
export { ElevatedCard, ElevatedCardHeader, ElevatedCardTitle, ElevatedCardContent };
